
define('text!modules/reporting/campaigns/technology/templates/layout.html',[],function () { return '<div class="report-chart chart-series"></div>\n<div class="report-controls {{#chartHidden}}collapsed{{/chartHidden}}"></div>\n<div class="report-grid no-chart"></div>\n';});

